// Carries an optional "where am I" context into the global Captain copilot so a
// page (today: the help center) can open the copilot pre-seeded with the entity
// the user is looking at. The context is sent with each message and rendered
// server-side as a system message (see ChatService#help_center_context), which
// lets the model act on the right article/portal without a lookup round-trip.
const state = {
  context: null,
  prefill: '',
};

const getters = {
  context: s => s.context,
  prefill: s => s.prefill,
  hasContext: s => !!s.context,
};

const mutations = {
  set(s, payload = {}) {
    s.context = payload.context || null;
    s.prefill = payload.prefill || '';
  },
  clear(s) {
    s.context = null;
    s.prefill = '';
  },
};

const actions = {
  open({ commit }, payload) {
    commit('set', payload);
  },
  close({ commit }) {
    commit('clear');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
